import axios from 'utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: {
    isLoading: false,
    error: false,
    data: [],
    count: 0,
  },
};

const slice = createSlice({
  name: 'approvedConsumptionTransactions',
  initialState,
  reducers: {
    // List loading
    startLoadingList(state) {
      state.list.isLoading = true;
    },
    hasErrorList(state, action) {
      state.list.isLoading = false;
      state.list.error = action.payload;
    },
    getApprovedConsumptionTransactionsSuccess(state, action) {
      state.list.isLoading = false;
      state.list.data = action.payload.approvedConsumptionTransactions;
      state.list.count = action.payload.count;
    },
    addApprovedConsumptionTransactionSuccess(state, action) {
      state.list.isLoading = false;
      state.list.data = [action.payload, ...state.list.data];
      state.list.count += 1;
    },
    deleteApprovedConsumptionTransactionSuccess(state, action) {
      state.list.isLoading = false;
      state.list.data = state.list.data.filter((item) => item.id !== action.payload);
      state.list.count -= 1;
    },
  },
});

export default slice.reducer;

export function getApprovedConsumptionTransactions(appId, page = 0, pageSize = 10, search = []) {
  return async (dispatch) => {
    const searchQuery = search.length > 0 ? `&search=${JSON.stringify(search)}` : '';
    dispatch(slice.actions.startLoadingList());
    try {
      const response = await axios.get(
        `/revenue-management/${appId}/approved-consumption-transactions?order=createdAt${searchQuery}&ordering=desc&page=${page}&limit=${pageSize}`,
      );

      dispatch(slice.actions.getApprovedConsumptionTransactionsSuccess(response));
    } catch (error) {
      console.error('Error fetching approved consumption transactions:', error);
      dispatch(slice.actions.hasErrorList(error));
    }
  };
}

export function addApprovedConsumptionTransaction(appId, transactionId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoadingList());
    try {
      const response = await axios.post(`/revenue-management/${appId}/approved-consumption-transactions`, {
        transactionId,
      });
      dispatch(slice.actions.addApprovedConsumptionTransactionSuccess(response));
      return { success: true };
    } catch (error) {
      console.error('Error adding approved consumption transaction:', error);
      dispatch(slice.actions.hasErrorList(error));
      return { success: false, error };
    }
  };
}

export function deleteApprovedConsumptionTransaction(appId, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoadingList());
    try {
      await axios.delete(`/revenue-management/${appId}/approved-consumption-transactions/${id}`);
      dispatch(slice.actions.deleteApprovedConsumptionTransactionSuccess(id));
      return { success: true };
    } catch (error) {
      console.error('Error deleting approved consumption transaction:', error);
      dispatch(slice.actions.hasErrorList(error));
      return { success: false, error };
    }
  };
}
